module.exports = "Ruzica Simonic\nUAE\nKhalidiya\nruzica.simonic@gmail.com\n+971 52 8647 673\n"